export default function CrossIcon({ ...rest }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='21'
      viewBox='0 0 22 22'
      fill='none'
      {...rest}
    >
      <circle cx='10.5' cy='10.5' r='9.5' stroke='currentColor' strokeWidth='2' />
      <path d='M7.30469 7.30432L13.696 13.6956' stroke='currentColor' strokeWidth='2' />
      <path d='M13.6958 7.30432L7.3045 13.6956' stroke='currentColor' strokeWidth='2' />
    </svg>
  );
}
